export const WIDGET_GET_PATIENTS_WITH_NO_READINGS = 'widget-patients-with-no-readings';
export const WIDGET_GET_PATIENTS_WITH_NO_READINGS_RESULT = `${WIDGET_GET_PATIENTS_WITH_NO_READINGS}/result`;
export const WIDGET_GET_PATIENTS_WITH_NO_READINGS_ERROR = `${WIDGET_GET_PATIENTS_WITH_NO_READINGS}/error`;
